"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SIAInformNewsletter;
var _react = _interopRequireDefault(require("react"));
var _InformLogo = _interopRequireDefault(require("./InformLogo/InformLogo"));
var _EventOccurence = _interopRequireDefault(require("./EventOccurence/EventOccurence"));
var _EventList = _interopRequireDefault(require("./EventsList/EventList"));
var _InformNewsletterContent = _interopRequireDefault(require("./InformNewsletterContent/InformNewsletterContent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-informnewsletter {\n  max-width: 672px;\n  margin: auto;\n  font-family: 'Helvetica Neue LT Roman';\n  color: #000000; }\n  .sia-informnewsletter a {\n    color: #000000; }\n";
  const fileName = "SIAInformNewsletter_SIAInformNewsletter";
  const element = document.querySelector("style[data-sass-component='SIAInformNewsletter_SIAInformNewsletter']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
function SIAInformNewsletter(_ref) {
  let {
    item,
    lang,
    agendaInformUrl,
    translate
  } = _ref;
  const occurence = item?.sia_inform_event_occurence?.[0];
  const event_occurrences = item.event_occurrences;
  const italian_event_occurences = item.italian_event_occurences;
  const optional_title = item?.optional_title;
  const optional_lead = item?.optional_lead;
  const newsletter_date = item.send_time?.[0]?.value;
  const event_labels = item.sia_newsletter_labels;
  const agenda_url = item.agenda_url;
  const newsletter_content = item.newsletter_content;
  const ocurrences_bg_color = item?.ocurrences_bg_color?.color_code;
  const ocurrences_bg_color_it = item?.ocurrences_bg_color_it?.color_code;
  const agenda_bg_color = item?.agenda_bg_color?.color_code;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-informnewsletter sia-padding-02-inline"
  }, /*#__PURE__*/_react.default.createElement(_InformLogo.default, {
    agendaInformUrl: agendaInformUrl
  }), /*#__PURE__*/_react.default.createElement(_EventOccurence.default, {
    lang: lang,
    occurence: occurence,
    event_labels: event_labels,
    optional_title: optional_title,
    optional_lead: optional_lead
  }), /*#__PURE__*/_react.default.createElement(_EventList.default, {
    event_occurrences: event_occurrences,
    italian_event_occurences: italian_event_occurences,
    newsletter_date: newsletter_date,
    event_labels: event_labels,
    agenda_url: agenda_url,
    lang: lang,
    ocurrences_bg_color: ocurrences_bg_color,
    ocurrences_bg_color_it: ocurrences_bg_color_it,
    agenda_bg_color: agenda_bg_color
  }), /*#__PURE__*/_react.default.createElement(_InformNewsletterContent.default, {
    newsletter_content: newsletter_content,
    lang: lang,
    translate: translate
  }));
}